import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { badgeConfig } from './badgeConfig';
import HoverTooltip from './HoverTooltip';

const rarityOrder = { 'Common': 1, 'Uncommon': 2, 'Rare': 3, 'Epic': 4, 'Legendary': 5, 'Mythic': 6 };

const BadgeIconStrip = ({ badges = [], limit = 4 }) => {
    const { t } = useTranslation();
    const badgesToDisplay = useMemo(() => {
        if (!badges || badges.length === 0) return [];

        return badges
            .map(badgeId => {
                const config = badgeConfig[badgeId];
                if (!config) return null;
                return {
                    id: badgeId,
                    ...config,
                    name: t(`badges.${badgeId}.name`)
                };
            })
            .filter(badge => badge && badge.name) // Filter out nulls and badges not in the config
            .sort((a, b) => (rarityOrder[b.rarity] || 0) - (rarityOrder[a.rarity] || 0))
            .slice(0, limit);
    }, [badges, limit, t]);

    if (badgesToDisplay.length === 0) {
        return null;
    }

    return (
        <div className="inline-flex items-center gap-1.5 ml-2">
            {badgesToDisplay.map(badge => {
                const Icon = badge.icon;
                if (!Icon) return null;
                return (
                    <HoverTooltip key={badge.id} text={badge.name}>
                        <Icon size={16} className={badge.color} style={{ verticalAlign: 'middle' }} />
                    </HoverTooltip>
                );
            })}
        </div>
    );
};

export default BadgeIconStrip;
